<template>
  <base-spinner v-if="loading" />
  <div v-else>
    <b-alert :show="error && error.length ? true : false" variant="danger">
      <div v-if="Array.isArray(error)">
        <div class="d-flex flex-column my-1" v-for="(error_text, index) in error" :key="index">
          {{ error_text }}
        </div>
      </div>
      <div v-else>
        <div v-html="error || '&nbsp;'"></div>
      </div>
    </b-alert>
    <div class="border-cotainer"></div>

    <div class="event-view mt-2">
      <div v-if="events.filter((e) => findEvent(e)).length">
        <div
          v-for="(event, index) in events.filter((e) => findEvent(e))"
          :key="index"
          class="event"
        >
          <div
            v-if="event.id"
            class="block"
            :style="getBlockStyle(event)"
            @click.stop="$emit('eventClick', event)"
          >
            <div class="side-border" :style="getBlockStyle(event)"></div>
            <div class="event_id d-flex"><span>#</span>{{ event.trip_id }}</div>
            <!-- <div class="dot"></div>
            <div class="journey">
              {{ event.number_of_trips.toString().padStart(2, 0) }} Journeys
            </div> -->
            <div class="name">{{ event.client }}</div>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-for="e in 5" :key="e" class="event" style="height: 80px"></div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import NewReservationService from '@/services/new-reservation.service'

export default {
  props: ['selected_date', 'events', 'event_types'],
  emits: ['eventClick'],
  data() {
    return {
      loading: false,
      error: null,
    }
  },
  methods: {
    getBlockStyle(event) {
      const rec = this.event_types?.find((each) => each.value === event.type)
      return `background: ${rec.background};border: ${rec.border};`
    },
    findEvent(event) {
      return moment(event.date).isSame(moment(this.selected_date), 'day')
    },
  },
  i18n: {
    messages: {
      en: require('@/services/i18n/locales/en/reservationOperations.json'),
      ar: require('@/services/i18n/locales/ar/reservationOperations.json'),
    },
  },
}
</script>

<style lang="scss" scoped>
.slots-view {
  display: flex;
  align-items: center;
  .slots-text {
    font-weight: 400;
    font-size: 16px;
    color: var(--color-02);
    margin-inline-start: 0.5rem;
  }
  .count {
    font-weight: 400;
    color: var(--color-03);
  }
}

.border-cotainer {
  border: 1px solid var(--color-15);
}

.event-view {
  overflow: auto;
  max-height: 75vh;

  .event {
    border: 1px solid var(--color-15);
    border-top: 0;
    padding: 0.5rem;
  }
  .block {
    padding: 0.5rem;
    border-radius: 8px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    cursor: pointer;
    .side-border {
      height: 50px;
      width: 1px;
      margin-inline-start: 0.25rem;
    }
    .event_id {
      font-size: 14px;
      color: var(--color-17);
      margin-inline-start: 1rem;
      overflow-wrap: anywhere;
    }
    .dot {
      margin: 0rem 0.5rem;
      background: var(--color-17);
      border-radius: 50%;
      height: 5px;
      width: 5px;
    }

    .journey {
      color: var(--color-17);
      font-size: 12px;
    }

    .name {
      font-weight: 700;
      font-size: 16px;
      color: var(--color-17);
      margin-inline-start: 3rem;
    }
  }
}

.event-view::-webkit-scrollbar {
  width: 5px;
}

.event-view::-webkit-scrollbar-track {
  background: var(--color-44);
}

.event-view::-webkit-scrollbar-thumb {
  background: var(--color-23);
}

.event-view::-webkit-scrollbar-thumb:hover {
  background: var(--color-45);
}
</style>
